<ag-grid-angular
    [context]="context"
    [rowData]="rowData"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    class="ag-theme-quartz h-100p"
>
</ag-grid-angular>
